import restApi from "../../http.js";
import session from "../session.js";

export default class Api {
  getBuyerCreditLimit(buyerId) {
    return restApi({
      method: "GET",
      url: `/balance/credit-limit/${buyerId}`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      }
    })
  }
  getBuyer(){
    return restApi({
      method: "GET",
      url: '/balance/buyers',
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      }
    })
  }
  getBuyerToken() {
    return restApi({
      method: "GET",
      url: '/balance/payment-token',
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      }
    })
  }

  deletePaymentMethod(paymentType,paymentId){
    return restApi({
      method: "DELETE",
      url: `/balance/payment/${paymentType}/${paymentId}`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      }
    })
  }

  getCards() {
    return restApi({
      method: "GET",
      url: '/balance/payment-detail',
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      }
    })
  }

  getSignupLink(buyerId) {
    return restApi({
      method: "GET",
      url: `/balance/qualification/${buyerId}`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      }
    })
  }

  getTransactionToken(data) {
    return restApi({
      method: "POST",
      url: "/balance/transactions/create",
      data: data,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  createBalanceOrder(data) {
    return restApi({
      method: "POST",
      url: "/orders/balance",
      data: data,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}
